import OrganizationLogo from '@/components/OrganizationLogo/logo';
import { PageLayoutSidebarLogoContainer } from '@/components/PageLayout';
import { UserMenu } from '@/pages/HomePage/OrganizationPage/Header/UserMenu';
import { QuestionMenu } from '@/components';
import { useAuthUser } from '@/hooks';
import { useNavigate } from 'react-router-dom';

const DashboardHeader = () => {
  const { user } = useAuthUser();
  const navigate = useNavigate();

  const navigateToTab = () => {
    navigate({ pathname: '/', search: '' });
  };
  return (
    <div className="bg-surface-forced-dark flex justify-between items-center">
      <PageLayoutSidebarLogoContainer>
        <OrganizationLogo onClick={navigateToTab} className="cursor-pointer" width={52} />
      </PageLayoutSidebarLogoContainer>
      <div className="flex items-center gap-2">
        <QuestionMenu />
        {user && <UserMenu user={user} />}
      </div>
    </div>
  );
};

export default DashboardHeader;
